export default {
  receiveCodeText: "برای دریافت کد تایید بر روی دکمه ”دریافت کد“ بزنید",
  voiceConfirm: "کد تایید صوتی",
  receiveCode: "دریافت کد",
  securityConfirmText:
    "فعلا تایید امنیتی غیرفعال است و برای تراکنش نیازی به این بخش ندارید. می‌توانید برای ثبت نهایی تراکنش، روی دکمه زیر بزنید.",
  and: "و",
  email: "ایمیل",
  mobile: "موبایل",
  google: "گوگل"
};
